import { InsurancePlan, InsurancePlanControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Atish Bagate
 *
 * **/

interface UseCreateInsurancePlanDetailsParams {
  insurancePlan: InsurancePlan;
  xTENANTID?: string;
}

export const useCreateInsurancePlanDetails = () =>
  useMutationWithLoading(
    async ({ insurancePlan, xTENANTID }: UseCreateInsurancePlanDetailsParams) =>
      new InsurancePlanControllerApi(
        getConfigObject()
      ).createPatientInsurancePlan(insurancePlan, xTENANTID)
  );
